module.exports = __webpack_public_path__ + "h5/img/banner-hengfu.20b45a9c.png";